import { createSelector } from 'reselect';

export const selectContextMenu = createSelector(
  ({ contextMenu }) => contextMenu,
  ({ contextMenu }) => contextMenu,
);
